<template>
  <section id="dashboard">
    <v-container class="fill-height">
      <!-- Select Filter -->
      <v-row justify="end" align="center">
        <v-col cols="4" md="auto" class="text-right pr-0">
          <small class="font-weight-medium">Colas:</small>
        </v-col>

        <v-col cols="8" md="auto">
          <v-switch v-model="QueueSearch" inset @change="requestDashboard"></v-switch>
        </v-col>

        <v-col cols="4" md="auto" class="text-right">
          <small class="font-weight-medium">Mostrar por:</small>
        </v-col>

        <v-col cols="8" md="auto" lg="2">
          <v-select
            :disabled="!render"
            :items="DateItems"
            v-model="DateSearch"
            filled
            rounded
            single-line
            dense
            class="rounded-small"
            hide-details
            @change="requestDashboard"
          ></v-select>
        </v-col>
      </v-row>

      <!-- Graphs -->

      <!-- Slider minicard for Mobiles -->
      <!-- <v-slide-group class="mt-2" v-if="isMobile && render">
        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>
      </v-slide-group> -->
      <!-- Minicards for Desktops -->
      <v-row>
        <v-col cols="12" md="3">
          <v-card outlined class="py-3" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image" height="150">
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card outlined class="py-3" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image" height="150">
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card outlined class="py-3" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image" height="150">
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card outlined class="py-3" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image" height="150">
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="5">
          <v-card class="shadow-5" v-if="render" style="height: inehit;">
            <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
              Total de llamadas: {{ totalCalls }}
            </v-card-title>
            <v-card-text>
              <apexchart ref="chart5" type="donut" :options="optionsDonutCalls" :series="serieDonut"></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="card"> </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="7">
          <v-card class="shadow-5" v-if="render">
            <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
              Distribución de llamadas por tiempo
            </v-card-title>
            <v-card-text>
              <apexchart ref="chart6" type="line" :options="optionsLine" :series="serieLine"></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="card"> </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-skeleton-loader :loading="!render" transition="scale-transition" class="mx-auto" type="card">
            <v-card class="shadow-5">
              <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                Llamadas entrantes por extensión: {{ totalIncomingCalls }}
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart7"
                  type="bar"
                  :options="optionsBarIncomingCalls"
                  :series="barIncomingCalls"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="6">
          <v-skeleton-loader :loading="!render" transition="scale-transition" class="mx-auto" type="card">
            <v-card class="shadow-5">
              <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                Llamadas salientes por extensión: {{ totalOutgoingCalls }}
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart8"
                  type="bar"
                  :options="optionsBarOutgoingCalls"
                  :series="barOutgoingCalls"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-skeleton-loader :loading="!render" transition="scale-transition" class="mx-auto" type="card">
            <v-card class="shadow-5">
              <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                Frecuencia llamadas entrantes por cliente: {{ totalIncomingFrecuency }}
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chartIncomingFrecuency"
                  type="donut"
                  :options="optionsFrecuencyDonut"
                  :series="serieIncomingFrecuencyDonut"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="6">
          <v-skeleton-loader :loading="!render" transition="scale-transition" class="mx-auto" type="card">
            <v-card class="shadow-5">
              <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                Frecuencia llamadas salientes por cliente: {{ totalOutgoingFrecuency }}
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chartOutgoingFrecuency"
                  type="donut"
                  :options="optionsFrecuencyDonut"
                  :series="serieOutgoingFrecuencyDonut"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services";
import { generateDonutOptions } from "@/utils/charts";
import { getDateObject } from "./utils";
export default {
  inject: ["theme"],

  data() {
    return {
      render: false,
      userData: {},
      DateItems: ["Hoy", "Ayer", "Mes Actual", "Mes Anterior"],
      QueueSearch: false,
      DateSearch: "Hoy",
      // CONFIGURACIONES PARA GRÁFICAS
      totalCalls: 0,
      totalOutgoingCalls: 0,
      totalIncomingCalls: 0,
      // Frecuency
      totalIncomingFrecuency: 0,
      totalOutgoingFrecuency: 0,
      optionsFrecuencyDonut: generateDonutOptions(["Una vez", "Dos veces", "Tres veces", "4 veces", "Mas de 4 veces"]),
      serieIncomingFrecuencyDonut: [0, 0, 0, 0, 0],
      serieOutgoingFrecuencyDonut: [0, 0, 0, 0, 0],
      optionsMiniCardsAreaIncoming: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Llamadas entrantes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#00BCD4"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionsMiniCardsAreaOutgoing: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Llamadas salientes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#2196F3"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },

      optionsMiniCardsBarIncoming: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Extensiones entrantes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#625FA4"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionsMiniCardsBarOutgoing: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Extensiones salientes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#AB47BC"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },

      optionsDonutCalls: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: ["Entrantes", "Salientes"],
      },

      optionsBarIncomingCalls: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "11px", // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        fill: {
          //   colors: ["#6D71F9"],
          colors: ["#008FFB"],
        },
      },
      optionsBarOutgoingCalls: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "11px", // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        fill: {
          colors: ["#00E396"],
          //   colors: ["#FEB019"],
        },
      },

      optionsLine: {
        theme: {
          mode: "light",
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
          tickPlacement: "on",
        },
        colors: ["#008FFB", "#00E396", "#FEB019"],
      },

      // DATOS PARA GRÁFICAS
      serieDonut: [0, 0],

      serieLine: [
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      barIncomingCalls: [
        {
          name: "Llamadas entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      barOutgoingCalls: [
        {
          name: "Llamadas salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      seriesMiniCardIncomingArea: [
        {
          name: "Llamadas entrantes.",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesMiniCardOutgoingArea: [
        {
          name: "Llamadas salientes.",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      seriesMiniCardIncomingBar: [
        {
          name: "Llamadas entrantes por extensión",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesMiniCardOutgoingBar: [
        {
          name: "Llamadas salientes por extensión",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    };
  },

  computed: {
    // DashboardDayValues() {
    //     return this.$store.getters["dashboard/GET_DASHBOARD_DAY"];
    // },

    // DashboardMonthValues() {
    //     return this.$store.getters["dashboard/GET_DASHBOARD_MONTH"];
    // },

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    welcomeCardHeight() {
      if (this.$vuetify.breakpoint.mobile) {
        return "200";
      } else {
        return "150";
      }
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.requestDashboard();
  },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
  },

  updated() {
    this.changeThemeChart();
  },

  // methods: {
  //   requestDashboard() {
  //     let value = this.DateSearch;

  //     this.render = false;
  //     this.clearAllGraphics();

  //     switch (value) {
  //       case "Día":
  //         this.getDashboardDayValues();
  //         break;

  //       case "Mes":
  //         this.getDashboardMonthValues();
  //         break;

  //       default:
  //         this.getDashboardDayValues();
  //         break;
  //     }
  //   },

  //   async getDashboardDayValues() {
  //     try {
  //       const response = await this.$store.dispatch(
  //         "dashboard/DASHBOARD_DAY_VALUES"
  //       );

  //       this.render = true;
  //       this.graphics(response.data);
  //     } catch (error) {
  //       this.$snotify.error(
  //         "No se pudo obtener las estadísticas del sistema.",
  //         "¡Error!"
  //       );
  //       console.error(error);
  //     }
  //   },

  //   async getDashboardMonthValues() {
  //     try {
  //       const response = await this.$store.dispatch(
  //         "dashboard/DASHBOARD_MONTH_VALUES"
  //       );

  //       this.render = true;
  //       this.graphics(response.data);
  //     } catch (error) {
  //       this.$snotify.error(
  //         "No se pudo obtener las estadísticas del sistema.",
  //         "¡Error!"
  //       );
  //       console.error(error);
  //     }
  //   },

  //   graphics(response) {
  //     // Gráfica de Mini Cards Entrantes //
  //     // Área
  //     this.optionsMiniCardsAreaIncoming.title.text = response.starters;
  //     this.optionsMiniCardsAreaIncoming.xaxis.categories = response.graph3H;
  //     this.seriesMiniCardIncomingArea[0].data = response.graph3B;

  //     // Barras
  //     this.optionsMiniCardsBarIncoming.title.text =
  //       response.graph2Starters.data.length;
  //     this.seriesMiniCardIncomingBar[0].data = response.graph2Starters.data.map(
  //       function(value) {
  //         return value.total;
  //       }
  //     );
  //     this.optionsMiniCardsBarIncoming.xaxis.categories = response.graph2Starters.data.map(
  //       function(value) {
  //         return value.extension;
  //       }
  //     );

  //     // Gráfica de Mini Cards Salientes //
  //     // Área
  //     this.optionsMiniCardsAreaOutgoing.title.text = response.outgoing;
  //     this.optionsMiniCardsAreaOutgoing.xaxis.categories = response.graph3H;
  //     this.seriesMiniCardOutgoingArea[0].data = response.graph3A;

  //     //Barras
  //     this.optionsMiniCardsBarOutgoing.title.text =
  //       response.graph2Outgoing.data.length;
  //     this.seriesMiniCardOutgoingBar[0].data = response.graph2Outgoing.data.map(
  //       function(value) {
  //         return value.total;
  //       }
  //     );
  //     this.optionsMiniCardsBarOutgoing.xaxis.categories = response.graph2Outgoing.data.map(
  //       function(value) {
  //         return value.extension;
  //       }
  //     );

  //     // Fin mini cards //

  //     // Gráfica dona
  //     this.totalCalls = response.starters + response.outgoing;
  //     this.totalIncomingCalls = response.starters;
  //     this.totalOutgoingCalls = response.outgoing;
  //     this.serieDonut = [response.starters, response.outgoing];

  //     // Grafica de tres líneas (Total, Entrantes y Salientes)
  //     this.optionsLine.xaxis.categories = response.graph3H;
  //     this.serieLine[0].data = response.graph3C;
  //     this.serieLine[1].data = response.graph3B;
  //     this.serieLine[2].data = response.graph3A;

  //     // Gráfica de barras Entrantes
  //     this.optionsBarIncomingCalls.xaxis.categories = response.graph2Starters.data.map(
  //       function(value) {
  //         return value.extension;
  //       }
  //     );
  //     this.barIncomingCalls[0].data = response.graph2Starters.data.map(function(
  //       value
  //     ) {
  //       return value.total;
  //     });

  //     // Gráfica de barras Salientes
  //     this.optionsBarOutgoingCalls.xaxis.categories = response.graph2Outgoing.data.map(
  //       function(value) {
  //         return value.extension;
  //       }
  //     );
  //     this.barOutgoingCalls[0].data = response.graph2Outgoing.data.map(function(
  //       value
  //     ) {
  //       return value.total;
  //     });
  //   },

  //   clearAllGraphics() {
  //     this.serieLine = [
  //       {
  //         name: "Total",
  //         data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //       },
  //       {
  //         name: "Entrantes",
  //         data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //       },
  //       {
  //         name: "Salientes",
  //         data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //       },
  //     ];

  //     this.optionsLine.xaxis.categories = [];
  //   },

  methods: {
    requestDashboard() {
      let value = this.DateSearch;

      this.render = false;
      this.clearAllGraphics();

      switch (value) {
        case "Hoy":
          this.getDashboardDayValues();
          break;
        case "Ayer":
          this.getDashboardYesterdayValues();
          break;

        case "Mes Actual":
          this.getDashboardMonthValues();
          break;
        case "Mes Anterior":
          this.getDashboardMonthYesterdayValues();
          break;

        default:
          this.getDashboardDayValues();
          break;
      }
    },

    async getFrecuencyData(date) {
      const params = getDateObject(date);

      const { data: queueFrecuency } = await PbxHttpClient.get("/report_call_quantity", { params });

      const { incoming_frequency, outgoing_frequency } = queueFrecuency;
      this.totalIncomingFrecuency = incoming_frequency.total;
      this.totalOutgoingFrecuency = outgoing_frequency.total;

      this.serieIncomingFrecuencyDonut = [
        incoming_frequency.one_time,
        incoming_frequency.two_times,
        incoming_frequency.three_times,
        incoming_frequency.four_times,
        incoming_frequency.more_than_four,
      ];

      this.serieOutgoingFrecuencyDonut = [
        outgoing_frequency.one_time,
        outgoing_frequency.two_times,
        outgoing_frequency.three_times,
        outgoing_frequency.four_times,
        outgoing_frequency.more_than_four,
      ];
    },

    async getDashboardDayValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        const response = await this.$store.dispatch("dashboard/DASHBOARD_DAY_VALUES", {
          yesterday: false,
          is_queue: this.QueueSearch,
        });

        await this.getFrecuencyData("TODAY");

        this.render = true;

        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error("No se pudo obtener las estadísticas del sistema.", "¡Error!");
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getDashboardYesterdayValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        const response = await this.$store.dispatch("dashboard/DASHBOARD_DAY_VALUES", {
          yesterday: true,
          is_queue: this.QueueSearch,
        });

        await this.getFrecuencyData("YESTERDAY");

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error("No se pudo obtener las estadísticas del sistema.", "¡Error!");
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getDashboardMonthValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        const response = await this.$store.dispatch("dashboard/DASHBOARD_MONTH_VALUES", {
          yesterday: false,
          is_queue: this.QueueSearch,
        });

        await this.getFrecuencyData("CURRENT_MONTH");

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error("No se pudo obtener las estadísticas del sistema.", "¡Error!");
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
    async getDashboardMonthYesterdayValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        const response = await this.$store.dispatch("dashboard/DASHBOARD_MONTH_VALUES", {
          yesterday: true,
          is_queue: this.QueueSearch,
        });

        await this.getFrecuencyData("LAST_MONTH");

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error("No se pudo obtener las estadísticas del sistema.", "¡Error!");
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    graphics(response) {
      // Gráfica de Mini Cards Entrantes //
      // Área
      this.optionsMiniCardsAreaIncoming.title.text = response.starters;
      this.optionsMiniCardsAreaIncoming.xaxis.categories = response.graph3H;
      this.seriesMiniCardIncomingArea[0].data = response.graph3B;

      // Barras
      this.optionsMiniCardsBarIncoming.title.text = response.graph2Starters.data.length;
      this.seriesMiniCardIncomingBar[0].data = response.graph2Starters.data.map(function(value) {
        return value.total;
      });
      this.optionsMiniCardsBarIncoming.xaxis.categories = response.graph2Starters.data.map(function(value) {
        return value.extension;
      });

      // Gráfica de Mini Cards Salientes //
      // Área
      this.optionsMiniCardsAreaOutgoing.title.text = response.outgoing;
      this.optionsMiniCardsAreaOutgoing.xaxis.categories = response.graph3H;
      this.seriesMiniCardOutgoingArea[0].data = response.graph3A;

      //Barras
      this.optionsMiniCardsBarOutgoing.title.text = response.graph2Outgoing.data.length;
      this.seriesMiniCardOutgoingBar[0].data = response.graph2Outgoing.data.map(function(value) {
        return value.total;
      });
      this.optionsMiniCardsBarOutgoing.xaxis.categories = response.graph2Outgoing.data.map(function(value) {
        return value.extension;
      });

      // Fin mini cards //

      // Gráfica dona
      this.totalCalls = response.starters + response.outgoing;
      this.totalIncomingCalls = response.starters;
      this.totalOutgoingCalls = response.outgoing;
      this.serieDonut = [response.starters, response.outgoing];

      // Grafica de tres líneas (Entrantes y Salientes y Total)
      this.optionsLine.xaxis.categories = response.graph3H;
      this.serieLine[0].data = response.graph3B;
      this.serieLine[1].data = response.graph3A;
      this.serieLine[2].data = response.graph3C;

      // Gráfica de barras Entrantes
      this.optionsBarIncomingCalls.xaxis.categories = response.graph2Starters.data.map(function(value) {
        return value.extension;
      });
      this.barIncomingCalls[0].data = response.graph2Starters.data.map(function(value) {
        return value.total;
      });

      // Gráfica de barras Salientes
      this.optionsBarOutgoingCalls.xaxis.categories = response.graph2Outgoing.data.map(function(value) {
        return value.extension;
      });
      this.barOutgoingCalls[0].data = response.graph2Outgoing.data.map(function(value) {
        return value.total;
      });
    },

    clearAllGraphics() {
      this.serieLine = [
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ];

      this.optionsLine.xaxis.categories = [];
    },

    changeThemeChart() {
      if (this.$refs.chart1 !== undefined) {
        if (this.isDark) {
          this.$refs.chart1.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart2.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart3.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart4.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart5.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart6.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart7.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart8.updateOptions({ theme: { mode: "dark" } }, true);
        } else {
          this.$refs.chart1.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart2.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart3.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart4.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart5.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart6.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart7.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart8.updateOptions({ theme: { mode: "light" } }, true);
        }
      }
    },
  },
};
</script>
